/*eslint-disable*/
import React, { useState } from "react";
import Body from "./Body";
import elementryLogo from "../../../../../assets/Images/elementary-logo.png";

const Salaries = () => {
  const [salarySlipData, setSalarySlipData] = useState({
    school: {
      name: "Elementary School of Business and Social Sciences",
      logo: elementryLogo,
    },
    slipDetails: {
      id: "23457289056",
      dateTime: "10:30 AM, 02 Oct, 2025",
    },
    employee: {
      name: "Taufik Alam",
      id: "#987654325",
      position: "Biology Teacher",
      grade: "A+",
      contact: "9876543210",
      address: "abc village, abc block, abc district, abc state, 722027",
    },
    billing: [
      {
        monthFor: "January",
        totalSalary: 20000,
        grossSalary: 18000,
      },
    ],
    others: {
      payScaleNote: "Your salary is according to institute pay scale.",
      paymentMode: "Net Banking",
      dispatchedBy: "Jahir Ahmed",
    },
  });
  const [salaryTableData, setSalaryTableData] = useState([
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      name: "Toufik Alam",
      position: "Office boy",
      profileId: "#98765432",
      totalSalary: "₹ 20,000",
      grade: "A+",
      grossSalary: "₹ 18,000",
      paymentMode: "UPI",
      dispatchedBy: "Jaheer Ahmad",
      receipt: true,
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      name: "Toufik Alam",
      position: "Clerk",
      profileId: "#98765432",
      totalSalary: "₹ 20,000",
      grade: "A+",
      grossSalary: "₹ 18,000",
      paymentMode: "Cash",
      dispatchedBy: "Jaheer Ahmad",
      receipt: true,
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      name: "Toufik Alam",
      position: "Teacher",
      profileId: "#98765432",
      totalSalary: "₹ 20,000",
      grade: "A+",
      grossSalary: "₹ 18,000",
      paymentMode: "Check",
      dispatchedBy: "Jaheer Ahmad",
      receipt: true,
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      name: "Toufik Alam",
      position: "Clerk",
      profileId: "#98765432",
      totalSalary: "₹ 20,000",
      grade: "A+",
      grossSalary: "₹ 18,000",
      paymentMode: "Net banking",
      dispatchedBy: "Jaheer Ahmad",
      receipt: true,
    },
    {
      receiptId: "23457289056",
      time: "10:24 AM",
      name: "Toufik Alam",
      position: "Teacher",
      profileId: "#98765432",
      totalSalary: "₹ 20,000",
      grade: "A+",
      grossSalary: "₹ 18,000",
      paymentMode: "Cash",
      dispatchedBy: "Jaheer Ahmad",
      receipt: true,
    },
  ]);
  const [historyTableData, setHistoryTableData] = useState([
    {
      receiptId: "98765432109284",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      totalSalary: "₹ 20,000",
      grossSalary: "₹ 18,000",
      month: "October",
      paymentMode: "Net Banking",
      dispatchedBy: "Jaheer Ahmad",
    },
    {
      receiptId: "98765432109284",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      totalSalary: "₹ 20,000",
      grossSalary: "₹ 18,000",
      month: "September",
      paymentMode: "Cash",
      dispatchedBy: "Jaheer Ahmad",
    },
    {
      receiptId: "98765432109284",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      totalSalary: "₹ 20,000",
      grossSalary: "₹ 18,000",
      month: "August",
      paymentMode: "UPI",
      dispatchedBy: "Jaheer Ahmad",
    },
    {
      receiptId: "98765432109284",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      totalSalary: "₹ 20,000",
      grossSalary: "₹ 18,000",
      month: "July",
      paymentMode: "UPI",
      dispatchedBy: "Jaheer Ahmad",
    },
    {
      receiptId: "98765432109284",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      totalSalary: "₹ 20,000",
      grossSalary: "₹ 18,000",
      month: "June",
      paymentMode: "Cash",
      dispatchedBy: "Jaheer Ahmad",
    },
    {
      receiptId: "98765432109284",
      time: "10:24 AM",
      date: "27 Dec, 2024",
      totalSalary: "₹ 20,000",
      grossSalary: "₹ 18,000",
      month: "May",
      paymentMode: "Cash",
      dispatchedBy: "Jaheer Ahmad",
    },
  ]);
  const _this = { salarySlipData, salaryTableData, historyTableData };
  return <Body {..._this} />;
};

export default Salaries;
